import React, { Component } from 'react';
import {
  Form,
  Grid,
  Header,
  Icon,
  Message,
  Segment,
  Transition,
} from 'semantic-ui-react';
import Utils from '../Utils.js';

class SocialFields extends Component {
  constructor(props) {
    super(props);

    this.state = {
      capacities: props.capacities,

      no_url_warning: false,

      errors: {
        facebook: false,
        instagram: false,
        twitter: false,
        youtube: false,
      },

      facebook: { on: false, value: '', },
      instagram: { on: false, value: '', },
      twitter: { on: false, value: '', },
      youtube: { on: false, value: '', },
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ capacities: nextProps.capacities, });
  }

  onFacebook = (event, data) => {
    let t = this.state.facebook;
    t.value = data.value;
    if (t.on && t.value.length === 0) {
      let err = this.state.errors;
      err.facebook = true;
      this.setState({ errors: err, });
    } else if (t.on && this.state.errors.facebook) {
      let err = this.state.errors;
      err.facebook = false;
      this.setState({ errors: err, });
    }
    this.props.onFacebook(t.value);
    this.setState({ facebook: t, });
    setTimeout(() => { this.noUrl(); }, 50);
  }

  toggleFacebook = () => {
    let t = this.state.facebook;
    t.on = !t.on;
    if (!t.on) {
      this.props.onFacebook('');
      t.value = '';
      this.setState({ facebook: t });
      setTimeout(() => { this.noUrl(); }, 50);
      return;
    }
    this.setState({ facebook: t, });
    setTimeout(() => { this.noUrl(); }, 50);
  }

  onInstagram = (event, data) => {
    let t = this.state.instagram;
    t.value = data.value;
    if (t.on && t.value.length === 0) {
      let err = this.state.errors;
      err.instagram = true;
      this.setState({ errors: err, });
    } else if (t.on && this.state.errors.instagram) {
      let err = this.state.errors;
      err.instagram = false;
      this.setState({ errors: err, });
    }
    this.props.onInstagram(t.value);
    this.setState({ instagram: t, });
    setTimeout(() => { this.noUrl(); }, 50);
  }

  noUrl = () => {
    let f = (value) => {
      if (value.indexOf('://') !== -1 || value.indexOf('www.') !== -1) {
        return true;
      } else {
        return false;
      }
    }

    if (f(this.state.instagram.value) || f(this.state.facebook.value) ||
        f(this.state.twitter.value) || f(this.state.youtube.value)) {
      this.setState({
        no_url_warning: true,
      });
    } else {
      this.setState({
        no_url_warning: false,
      });
    }
  }

  toggleInstagram = () => {
    let t = this.state.instagram;
    t.on = !t.on;
    if (!t.on) {
      this.props.onInstagram('');
      t.value = '';
      this.setState({ instagram: t });
      setTimeout(() => { this.noUrl(); }, 50);
      return;
    }
    this.setState({ instagram: t, });
    setTimeout(() => { this.noUrl(); }, 50);
  }

  onTwitter = (event, data) => {
    let t = this.state.twitter;
    t.value = data.value;
    if (t.on && t.value.length === 0) {
      let err = this.state.errors;
      err.twitter = true;
      this.setState({ errors: err, });
    } else if (t.on && this.state.errors.twitter) {
      let err = this.state.errors;
      err.twitter = false;
      this.setState({ errors: err, });
    }
    this.props.onTwitter(t.value);
    this.setState({ twitter: t, });
    setTimeout(() => { this.noUrl(); }, 50);
  }

  toggleTwitter = () => {
    let t = this.state.twitter;
    t.on = !t.on;
    if (!t.on) {
      this.props.onTwitter('');
      t.value = '';
      this.setState({ twitter: t });
      setTimeout(() => { this.noUrl(); }, 50);
      return;
    }
    this.setState({ twitter: t, });
    setTimeout(() => { this.noUrl(); }, 50);
  }

  onYouTube = (event, data) => {
    let t = this.state.youtube;
    t.value = data.value;
    if (t.on && t.value.length === 0) {
      let err = this.state.errors;
      err.youtube = true;
      this.setState({ errors: err, });
    } else if (t.on && this.state.errors.youtube) {
      let err = this.state.errors;
      err.youtube = false;
      this.setState({ errors: err, });
    }
    this.props.onYouTube(t.value);
    this.setState({ youtube: t, });
    setTimeout(() => { this.noUrl(); }, 50);
  }

  toggleYouTube = () => {
    let t = this.state.youtube;
    t.on = !t.on;
    if (!t.on) {
      this.props.onYouTube('');
      t.value = '';
      this.setState({ youtube: t });
      setTimeout(() => { this.noUrl(); }, 50);
      return;
    }
    this.setState({ youtube: t, });
    setTimeout(() => { this.noUrl(); }, 50);
  }

  render() {
    if (Utils.hasNoneCapacities(this.state.capacities, ['twitter', 'youtube', 'facebook', 'instagram'])) {
      return null;
    }

    return (
      <Grid columns={1} stackable>
        <Grid.Column>
          <Segment>
            <Header as='h2' textAlign='left'>
              <Icon name='heart outline' />
              <Header.Content>Social Accounts</Header.Content>
              <Header.Subheader>In order to display your socials accounts, fill them here. They are <strong>not</strong> mandatory.</Header.Subheader>
            </Header>
          </Segment>
        </Grid.Column>
        <Transition animation='fade' visible={this.state.no_url_warning}><Grid.Row columns={1}><Grid.Column>
            <Message visible={this.state.no_url_warning} warning content="You don't need to put the URL, just put your handle." />
        </Grid.Column></Grid.Row></Transition>
        {Utils.hasNoneCapacities(this.state.capacities, ['twitter','youtube','facebook','instagram']) &&
        <Grid.Column>
          <Segment basic>
            This theme doesn't need to configure social accounts labels. Please continue or select another theme.
          </Segment>
        </Grid.Column>}

        {Utils.hasCapacity(this.state.capacities, 'twitter') &&
        <Grid.Row columns={3}>
          <Grid.Column verticalAlign='middle' textAlign='left' width={2}>
            <Form.Checkbox checked={this.state.twitter.on} onChange={this.toggleTwitter} label="Twitter" />
          </Grid.Column>
          <Grid.Column verticalAlign='middle' textAlign='left'  width={1}>
            <Icon name='twitter' disabled={!this.state.twitter.on} />
          </Grid.Column>
          <Grid.Column width={9}>
            <Form.Field>
              <Form.Input disabled={!this.state.twitter.on} value={this.state.twitter.value} error={this.state.errors.twitter} onChange={this.onTwitter} placeholder="Twitter Handle" />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>}

        {Utils.hasCapacity(this.state.capacities, 'youtube') &&
        <Grid.Row columns={3}>
          <Grid.Column verticalAlign='middle' textAlign='left' width={2}>
            <Form.Checkbox checked={this.state.youtube.on} onChange={this.toggleYouTube} label="YouTube" />
          </Grid.Column>
          <Grid.Column verticalAlign='middle' textAlign='left'  width={1}>
            <Icon name='youtube' disabled={!this.state.youtube.on} />
          </Grid.Column>
          <Grid.Column width={9}>
            <Form.Field>
              <Form.Input disabled={!this.state.youtube.on} value={this.state.youtube.value} error={this.state.errors.youtube} onChange={this.onYouTube} placeholder="YouTube Handle" />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>}

        {Utils.hasCapacity(this.state.capacities, 'facebook') &&
        <Grid.Row columns={3}>
          <Grid.Column verticalAlign='middle' textAlign='left' width={2}>
            <Form.Checkbox checked={this.state.facebook.on} onChange={this.toggleFacebook} label="Facebook" />
          </Grid.Column>
          <Grid.Column verticalAlign='middle' textAlign='left'  width={1}>
            <Icon name='facebook' disabled={!this.state.facebook.on} />
          </Grid.Column>
          <Grid.Column width={9}>
            <Form.Field>
              <Form.Input disabled={!this.state.facebook.on} value={this.state.facebook.value} error={this.state.errors.facebook} onChange={this.onFacebook} placeholder="Facebook Handle" />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>}

        {Utils.hasCapacity(this.state.capacities, 'instagram') &&
        <Grid.Row columns={3}>
          <Grid.Column verticalAlign='middle' textAlign='left' width={2}>
            <Form.Checkbox checked={this.state.instagram.on} onChange={this.toggleInstagram} label="Instagram" />
          </Grid.Column>
          <Grid.Column verticalAlign='middle' textAlign='left' width={1}>
            <Icon name='instagram' disabled={!this.state.instagram.on} />
          </Grid.Column>
          <Grid.Column width={9}>
            <Form.Field>
              <Form.Input disabled={!this.state.instagram.on} value={this.state.instagram.value} error={this.state.errors.instagram} onChange={this.onInstagram} placeholder="Instagram Handle" />
            </Form.Field>
          </Grid.Column>
        </Grid.Row>}
      </Grid>
    );
  }
}

export default SocialFields;



// WEBPACK FOOTER //
// ./src/tool/SocialFields.js